import { PromoWrapper } from "components/car/Promotions/PromoContainer"

function PreOwned() {
  return (
    <PromoWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <g fill="none" fillRule="evenodd">
          <circle cx="20" cy="20" r="20" fill="#FFC700" />
          <path
            fill="#FFF"
            d="M18.204 31.45l9.48-15.636c.215-.354-.089-.79-.513-.734l-6.306.82 1.507-7.575c.05-.255-.293-.402-.457-.194l-9.322 11.784c-.272.343.016.831.463.786L20.009 20l-2.28 11.28c-.054.271.33.41.475.17z"
          />
          <path
            fill="#E6E8F0"
            d="M15.508 19.08c-.174.013-.29-.17-.197-.311l6.969-10.68a.26.26 0 00-.366.04l-9.321 11.787c-.272.343.016.831.463.786L20.009 20l-2.28 11.28c-.03.151.077.258.202.284l3.906-11.837c.183-.555-.279-1.111-.884-1.065l-5.445.418z"
          />
        </g>
      </svg>
    </PromoWrapper>
  )
}

export default PreOwned
